/*
 * 定义总线
 */

export default function (injection, Vue) {
    const bus = new Vue();
    const queueLogined = [];
    const queueSitePriv = [];
    var loginedUser = null;
    var sitePriv = null;

    let config = {
        defaultLoginHandler: () => {},
        defaultLogoutHandler: () => {},
        defaultSitePrivHandler: () => {},
        ready: () => {}
    };

    bus.setConfig = function (conf) {
        Object.keys(conf).forEach(v => {
            config[v] = conf[v];
        });
        config.ready(Vue, config);
    };

    bus.$on('logined', (user) => {
        config.defaultLoginHandler();
        loginedUser = user;
        queueLogined.forEach((x) => {
            x.callback.call(x.context, user);
        });
    });

    bus.$on('sitepriv', (sp) => {
        config.defaultSitePrivHandler();
        sitePriv = sp;
        queueSitePriv.forEach((x) => {
            x.callback.call(x.context, sitePriv);
        });
    });

    bus.$on('logout', () => {
        config.defaultLogoutHandler();
        injection.storage(true).removeItem('currentSite');
        injection.storage(true).removeItem('site');
        window.location.href = injection.config.apiUrl.logout;
    });

    const toDoAfterLogined = function (callback, context = window) {
        if (loginedUser === null) {
            queueLogined.push({
                callback: callback,
                context: context
            });
        } else {
            Vue.nextTick(() => {
                callback.call(context, loginedUser);
            });
        }
    };

    const toDoAfterSitePrivFetched = function (callback, context = window) {
        if (sitePriv === null) {
            queueSitePriv.push({
                callback: callback,
                context: context
            });
        } else {
            Vue.nextTick(() => {
                callback.call(context, sitePriv);
            });
        }
    };

    const cancelMultipleSelect = function (callback, context = window) {
        callback();
    };

    Object.defineProperties(injection, {
        bus: {
            get () {
                return bus;
            }
        },
        logined: {
            get () {
                return toDoAfterLogined;
            }
        },
        sitePriv: {
            get () {
                return toDoAfterSitePrivFetched;
            }
        },
        cancelMultipleSelect: {
            get () {
                return cancelMultipleSelect;
            }
        }
    });

    Object.defineProperties(Vue.prototype, {
        $bus: {
            get () {
                return bus;
            }
        },
        $logined: {
            get () {
                return toDoAfterLogined;
            }
        },
        $sitePriv: {
            get () {
                return toDoAfterSitePrivFetched;
            }
        },
        cancelMultipleSelect: {
            get () {
                return cancelMultipleSelect;
            }
        }
    });
}
